import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const TextFormatUnderline16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M5.44321 2.51502C5.44321 2.23058 5.21426 2 4.93185 2C4.64943 2 4.42048 2.23058 4.42048 2.51502V7.9742C4.42048 9.96525 6.0231 11.5793 8.00002 11.5793C9.97695 11.5793 11.5795 9.96525 11.5795 7.9742V2.51502C11.5795 2.23058 11.3507 2 11.0682 2C10.7858 2 10.5568 2.23058 10.5568 2.51502V7.9742C10.5568 9.39638 9.41211 10.5493 8.00002 10.5493C6.58793 10.5493 5.44321 9.39638 5.44321 7.9742V2.51502ZM3.90909 13.176C3.68315 13.176 3.5 13.3603 3.5 13.588C3.5 13.8155 3.68315 14 3.90909 14H12.0909C12.3168 14 12.5 13.8155 12.5 13.588C12.5 13.3603 12.3168 13.176 12.0909 13.176H3.90909Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
